class TC_ContactForm {
    constructor () {
        if ($('.is-special-page #contact_form').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let self = this;
        this.form = $('.is-special-page #contact_form');
        this.usesChineseCaptcha = false;

        this.UI = {
            messages: {
                empty: this.form.find('.contact-form-message-empty'),
                error: this.form.find('.contact-form-message-error'),
                submitError: this.form.find('.contact-form-message-submit-error')
            },
            buttons: {
                submit: this.form.find('.contact-form-button'),
            },
            inputs: {
                name: this.form.find('input[name="name"]'),
                email: this.form.find('input[name="email"]'),
                subject: this.form.find('input[name="subject"]'),
                message: this.form.find('textarea[name="message"]'),
                return: this.form.find('input[name="return"]')
            }
        };

        if (!this.UI.buttons.submit.hasClass('g-recaptcha')) {
            this.UI.buttons.submit.on('click', e => {
                e.preventDefault();
                this.prepareForm();
            });
        }

        if (this.form.find('.nog-captcha-container').length) {
            this.usesChineseCaptcha = true;

            this.UI.captcha = {
                wrapper: this.form.find('.nog-captcha-container'),
            };

            this.UI.captcha.input = this.UI.captcha.wrapper.find('input');
            this.UI.captcha.refreshButton = this.UI.captcha.wrapper.find('.captcha-refresh');
            this.UI.captcha.refreshButton.on('click', e => {
                e.preventDefault();
                this.refreshChineseCaptcha();
            });
        }

        let inputsToClearErrors = ['name', 'email', 'subject', 'message'];

        for (let i = 0; i < inputsToClearErrors.length; i++) {
            this.UI.inputs[inputsToClearErrors[i]].on('keyup', e => {
                this.UI.inputs[inputsToClearErrors[i]].removeClass('is-invalid');
                this.checkIfAllIsFilled();
            });
        }

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.on('keyup', e => {
                this.UI.captcha.input.removeClass('is-invalid');
                this.checkIfAllIsFilled();
            });
        }
    }

    prepareForm () {
        if (this.isEmptyForm()) {
            if (!this.usesChineseCaptcha) {
                grecaptcha.reset();
            }

            return;
        }

        this.submitForm();
    }

    isEmptyForm () {
        let result = false;
        let inputs = ['name', 'email', 'subject', 'message'];
        this.UI.messages.error.addClass('is-hidden');
        this.UI.messages.submitError.addClass('is-hidden');

        for (let i = 0; i < inputs.length; i++) {
            if (this.UI.inputs[inputs[i]].val() === '') {
                this.UI.messages.empty.removeClass('is-hidden');
                this.UI.inputs[inputs[i]].addClass('is-invalid');
                result = true;
            }
        }

        if (this.usesChineseCaptcha) {
            if (
                this.UI.captcha.input.val() === '' ||
                this.UI.captcha.input.val() !== this.UI.captcha.wrapper.find('img').attr('data-captcha')
            ) {
                this.UI.messages.empty.removeClass('is-hidden');
                this.UI.captcha.input.addClass('is-invalid');
                result = true;
            }
        }

        return result;
    }

    checkIfAllIsFilled () {
        if (
            this.UI.inputs.name.val() !== '' &&
            this.UI.inputs.email.val() !== '' &&
            this.UI.inputs.subject.val() !== '' &&
            this.UI.inputs.message.val() !== '' &&
            (!this.usesChineseCaptcha || this.usesChineseCaptcha && this.UI.captcha.input.val() === '')
        ) {
            this.UI.messages.empty.addClass('is-hidden');
        }
    }

    formIsLoading () {
        this.UI.inputs.name.addClass('is-loading');
        this.UI.inputs.email.addClass('is-loading');
        this.UI.inputs.subject.addClass('is-loading');
        this.UI.inputs.message.addClass('is-loading');
        this.UI.buttons.submit.addClass('is-loading');

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.addClass('is-loading');
        }
    }

    formIsLoaded () {
        this.UI.inputs.name.removeClass('is-loading');
        this.UI.inputs.email.removeClass('is-loading');
        this.UI.inputs.subject.removeClass('is-loading');
        this.UI.inputs.message.removeClass('is-loading');
        this.UI.buttons.submit.removeClass('is-loading');

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.removeClass('is-loading');
        }
    }

    submitErrorOccurred (response = false) {
        this.UI.messages.submitError.removeClass('is-hidden');
    }

    handleResponse (responseObj) {
        let response = JSON.parse(responseObj.data);

        if (response.success === 0) {
            this.UI.messages.error.text(response.message);
            this.UI.messages.error.removeClass('is-hidden');
        } else {
            let wrapper = $('.contact-form');
            wrapper.addClass('is-success');
            wrapper.children().css('display', 'none');
            wrapper.find('.contact-form-success').css('display', 'block').removeClass('is-hidden');
        }
    }

    submitForm () {
        let requestUrl = window.CSITE.baseUrl + 'en/contact-us?option=com_ajax&index.php?option=com_ajax&template=christiansite&format=json&method=sendEmail';

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.error.addClass('is-hidden');
                this.UI.messages.empty.addClass('is-hidden');
                this.UI.messages.submitError.addClass('is-hidden');
                this.formIsLoading();
            },
            data: this.form.serialize(),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.formIsLoaded();
                this.handleResponse(response);

                if (!this.usesChineseCaptcha) {
                    grecaptcha.reset();
                } else {
                    this.refreshChineseCaptcha();
                }
            },
            error: () => {
                this.formIsLoaded();
                this.submitErrorOccurred();

                if (!this.usesChineseCaptcha) {
                    grecaptcha.reset();
                } else {
                    this.refreshChineseCaptcha();
                }
            }
        });
    }

    refreshChineseCaptcha () {
        let container = this.form.find('.nog-captcha-container');
        container.addClass('loading');

        $.ajax({
          url: '?option=com_ajax&module=calmradio_login&method=initCaptcha&format=raw&t=' + new Date().getTime(),
          method: "GET",
          type: "JSON",
          success: response => {
            try {
              container.removeClass('loading');
              let data = JSON.parse(response);
              this.form.find('.captcha-img').prop('src', data.image_src).attr('data-captcha', data.code);
            } catch (_error) {}
          }
        });
    }

    handleCaptchaError () {
        grecaptcha.reset();
        alert(window.CSITE_LANGS.recaptchaMessage);
    }
}
